// Static fallback rates — used only when fx_rates table is unreachable
// or for instant client-side conversions in the input UI.
// Server-side aggregations should prefer expenses.amount_eur (set at write time).
// Updated 2026-05-13 from frankfurter.dev (ECB) + bank.gov.ua (UAH).
export const RATES_AS_OF = '2026-05-13';
export const EXCHANGE_RATES = {
  EUR: 1.00,
  USD: 1.1715,
  GBP: 0.86713,
  UAH: 51.5014,
  BRL: 5.7449,
  JPY: 184.83,
  CHF: 0.9155,
  CAD: 1.6039,
  AUD: 1.6158,
  CNY: 7.9556,
} as const;

export const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  UAH: '₴',
  BRL: 'R$',
  JPY: '¥',
  CHF: 'CHF',
  CAD: 'CA$',
  AUD: 'A$',
  CNY: '¥',
} as const;

/**
 * Convert amount from one currency to another using static exchange rates
 * @param amount - The amount to convert
 * @param fromCurrency - The source currency code
 * @param toCurrency - The target currency code
 * @returns Converted amount rounded to 2 decimal places
 */
export const convertCurrency = (
  amount: number,
  fromCurrency: string,
  toCurrency: string
): number => {
  if (fromCurrency === toCurrency) return amount;
  
  const fromRate = EXCHANGE_RATES[fromCurrency as keyof typeof EXCHANGE_RATES] || 1;
  const toRate = EXCHANGE_RATES[toCurrency as keyof typeof EXCHANGE_RATES] || 1;
  
  // Convert to EUR first (base currency), then to target currency
  const inEUR = amount / fromRate;
  const converted = inEUR * toRate;
  
  return Math.round(converted * 100) / 100; // Round to 2 decimals
};

/**
 * Format currency amount with appropriate symbol
 * @param amount - The amount to format
 * @param currency - The currency code
 * @returns Formatted currency string (e.g., "€10.00")
 */
export const formatCurrency = (amount: number, currency: string): string => {
  const symbol = CURRENCY_SYMBOLS[currency as keyof typeof CURRENCY_SYMBOLS] || currency;
  return `${symbol}${amount.toFixed(2)}`;
};
